__turbopack_context__.v({
  "articles": "opyA5W_articles",
  "categories": "opyA5W_categories",
  "container": "opyA5W_container",
  "heading": "opyA5W_heading",
  "more": "opyA5W_more",
});
